angular.module('core').filter('lessons', ['numberFilter',
	function($numberFilter) {
		return function(input) {
			if(_.isUndefined(input) || !_.isNumber(input)) {
				return '';
			}
			else {
				if (input === 1) {
					return $numberFilter(input) + ' lesson';
				} else {
					return $numberFilter(input) + ' lessons';
				}
			}
		};
	}
]);
